import { adminHttpClient } from "../../../../commons/adminHttpClinet";

const deleteCategory = (id:string): Promise<any> => {
    return adminHttpClient.delete(`/api/Admin/AdminMarketplace/delete-category?Id=${id}`, null)
}
export default deleteCategory;

